import React, { FormEvent } from 'react'
import hash from '@emotion/hash'

export type FilterSubItemProps = {
  countries?: FilterSubItemProps[]
  filterType: string
  label: string
  type?: string
  value: string
  slug: string
}

export type EventFilterItemProps = {
  filterItems: FilterSubItemProps
  isChecked: boolean
  filterType: string
  updateFilters: (isAlreadySelected: boolean, value: FilterSubItemProps) => void
}

export const EventListingsFilterType = ({
  filterItems,
  isChecked,
  updateFilters
}: EventFilterItemProps) => {
  const handleLabelClick = (selectedItem: FilterSubItemProps) => {
    updateFilters(isChecked, selectedItem)
  }

  const handleInputChange = (
    event: FormEvent<HTMLInputElement>,
    selectedItem: FilterSubItemProps
  ) => {
    const { checked } = event.currentTarget
    updateFilters(!checked, selectedItem)
  }

  return (
    <li key={hash(Object.values(filterItems).join('#'))}>
      <input
        type="checkbox"
        checked={isChecked}
        className="checkbox"
        value={filterItems.value}
        onChange={(e) => handleInputChange(e, filterItems)}
      />
      <span
        className="event__filter-item"
        onClick={() => handleLabelClick(filterItems)}
        onKeyUp={() => handleLabelClick(filterItems)}
        role="presentation"
      >
        {filterItems.label}
      </span>
    </li>
  )
}
